import { openMailTo } from 'reactApp/modules/attaches/attaches.helpers';
import { sendXray } from 'reactApp/utils/ga';

export const writeEmailViaNewTab = (author: string) => {
    openMailTo(author);
    sendXray('write-email-new-tab_context-menu_shared-docs_success');
};
